export default __webpack_public_path__ + "app/images/f70bad0aaec87aef8383e41de52cc3bb.svg";